import React from "react";

export const project4en = {
  name: "project4",
  title: `Decoupled phylogenetic and functional diversity in European plant communities`,
  body: (
    <div>
      <div>
        <h3>Coordination</h3> Zdeňka Lososová
      </div>
      <div>
        <h3>Participants and collaborators</h3>
        Irena Axmanová, Natálie Čeplová, Jan Divíšek, Lars Götzenberger, Milan Chytrý, Veronika Kalusová, Jakub
        Těšitel, Martin Večeřa
      </div>
      <div>
        <h3>Funding</h3>
        <li>2018–2020 Czech Science Foundation, project nr. 18-02773S</li>
      </div>
      <div>
        <h3>Project Aims</h3>
        <div>
          We aim to identify current centres of phylogenetic (PD) and functional diversity (FD) in
          Europe and to provide insights into ecological and evolutionary processes that shape plant
          community structure. Our specific aims are:
        </div>
        <li>To identify communities in which PD and FD are decoupled.</li>
        <li>
          To detect effect of novel species interactions on decoupled PD, FD or both parts of
          diversity of European plant communities.
        </li>
      </div>
      <div className="project-publication">
        <h3>Publications</h3>
        <h4>Research papers</h4>
		<li><b>Lososová Z.</b>, <b>Divíšek J.</b>, <b>Chytrý M.</b>, <b>Götzenberger L.</b>, <b>Těšitel J.</b> & Mucina L. (2021): Macroevolutionary patterns in European vegetation. <i>Journal of Vegetation Science</i> 32: e12942. – {" "}
          <a href="https://doi.org/10.1111/jvs.12942">DOI</a>
        </li>
		<li>
          <b>Divíšek J.</b>, <b>Chytrý M.</b>, Beckage B., Gotelli N.J., <b>Lososová Z.</b>, Pyšek P., Richardson D.M. &
          Molofsky J. (2018): Similarity of introduced plant species to native ones facilitates
          naturalization, but differences enhance invasion success. <i>Nature Communications</i> 9: 4631. –{" "}
          <a href="https://www.nature.com/articles/s41467-018-06995-4.pdf">fulltext in pdf</a>
        </li>
        <li>
          Loiola P.P., de Bello F., <b>Chytrý M.</b>, Götzenberger L., Carmona C.P., Pyšek P. & <b> Lososová Z. </b> 
           (2018): Invaders among locals: Alien species decrease phylogenetic and functional
          diversity while increasing dissimilarity among native community members. <i>Journal of
          Ecology</i> 106: 2230–2241. –{" "}
          <a href="http://www.ibot.cas.cz/personal/pysek/pdf/Loiola et al_Invaders among locals_JEcol 2018(online early).pdf">
            fulltext in pdf
          </a>
        </li>
		<li>
          de Bello F., Šmilauer P., Diniz-Filho J.A.F., Carmona C.P., <b>Lososová Z.</b>, Herben T. &
          Götzenberger L. (2017): Decoupling phylogenetic and functional diversity to reveal hidden
          signals in community assembly. <i>Methods in Ecology and Evolution</i> 8: 1200–1211.
        </li>

   <li>
          <b>Lososová Z.</b>, <b>Čeplová N.</b>, <b>Chytrý M.</b>, <b>Tichý L.</b>, <b>Danihelka J.</b>, Fajmon K., <b>Láníková D.</b>,
          <b> Preislerová Z.</b> & <b>Řehořek V.</b> (2016): Is phylogenetic diversity a good proxy for functional
          diversity of plant communities? A case study from urban habitats. <i>Journal of Vegetation
          Science</i> 27: 1036–1046. –{" "}
          <a href="http://onlinelibrary.wiley.com/doi/10.1111/jvs.12414/epdf">
            fulltext in Wiley Online Library
          </a>
        </li>

<li>
          <b>Čeplová N.</b>, <b>Lososová Z.</b>, <b>Zelený D.</b>, <b>Chytrý M.</b>, <b>Danihelka J.</b>, Fajmon K., <b> Láníková D.</b>, <b>Preislerová Z.</b>, <b>Řehořek V.</b> &amp; <b>Tichý L.</b> (2015): Phylogenetic diversity of central-
          European urban plant communities: effects of alien species and habitat types. <i>Preslia</i> 87:
          1–16. –{" "}
          <a href="http://www.sci.muni.cz/botany/chytry/Ceplova_etal2015_Preslia.pdf">
            fulltext in PDF
          </a>
        </li>
        
        
     
        <li>
          <b>Lososová Z.</b>, <b>Šmarda P.</b>, <b>Chytrý M.</b>, Purschke O., Pyšek P., Sádlo J., <b>Tichý L.</b> & Winter M. 
          (2015): Phylogenetic structure of plant species pools reflects habitat age on the
          geological time scale. <i>Journal of Vegetation Science</i> 26: 1080–1089. –{" "}
          <a href="http://onlinelibrary.wiley.com/doi/10.1111/jvs.12308/epdf">
            fulltext in Wiley Online Library
          </a>
        </li>
        <h4>Popularizations</h4>
        <li>
          <b>Lososová Z.</b>, <b>Chytrý M.</b> & Pyšek P. (2018): Známe odpověď na Darwinovu naturalizační
          hádanku? <i>Živa</i> 5: 229–230. –{" "}
          <a href="http://www.ziva.avcr.cz/files/ziva/pdf/zname-odpoved-na-darwinovu-naturalizacni-hadanku.pdf">
            fulltext in pdf
          </a>
        </li>
      </div>
    </div>
  )
};

export const project4cz = {
  name: "project4",
  title: `Fylogenetická a funkční diverzita rostlinných společenstev`,
  body: (
    <div>
      <div>
        <h3>Koordinátor</h3> Zdeňka Lososová
      </div>
      <div>
        <h3>Spolupracovníci</h3>
        Irena Axmanová, Natálie Čeplová, Jan Divíšek, Lars Götzenberger, Milan Chytrý, Veronika Kalusová, Jakub
        Těšitel, Martin Večeřa
      </div>
      <div>
        <h3>Finanční podpora</h3>
        <li>2018–2020 Grantová agentura České republiky, projekt č. 18-02773S</li>
      </div>
      <div>
        <h3>Cíle</h3>
        <div>
          We aim to identify current centres of phylogenetic (PD) and functional diversity (FD) in
          Europe and to provide insights into ecological and evolutionary processes that shape plant
          community structure. Our specific aims are:
        </div>
        <li>To identify communities in which PD and FD are decoupled.</li>
        <li>
          To detect effect of novel species interactions on decoupled PD, FD or both parts of
          diversity of European plant communities.
        </li>
      </div>
      <div className="project-publication">
        <h3>Publikace</h3>
        <h4>Odborné články</h4>
			<li><b>Lososová Z.</b>, <b>Divíšek J.</b>, <b>Chytrý M.</b>, <b>Götzenberger L.</b>, <b>Těšitel J.</b> & Mucina L. (2021): Macroevolutionary patterns in European vegetation. <i>Journal of Vegetation Science</i> 32: e12942. – {" "}
          <a href="https://doi.org/10.1111/jvs.12942">DOI</a>
        </li>
        <li>
          <b>Divíšek J.</b>, <b>Chytrý M.</b>, Beckage B., Gotelli N.J., <b>Lososová Z.</b>, Pyšek P., Richardson D.M. &
          Molofsky J. (2018): Similarity of introduced plant species to native ones facilitates
          naturalization, but differences enhance invasion success. <i>Nature Communications</i> 9: 4631. –{" "}
          <a href="https://www.nature.com/articles/s41467-018-06995-4.pdf">fulltext in pdf</a>
        </li>
        <li>
          Loiola P.P., de Bello F., <b>Chytrý M.</b>, Götzenberger L., Carmona C.P., Pyšek P. & <b> Lososová Z. </b> 
           (2018): Invaders among locals: Alien species decrease phylogenetic and functional
          diversity while increasing dissimilarity among native community members. <i>Journal of
          Ecology</i> 106: 2230–2241. –{" "}
          <a href="http://www.ibot.cas.cz/personal/pysek/pdf/Loiola et al_Invaders among locals_JEcol 2018(online early).pdf">
            fulltext in pdf
          </a>
        </li>
		<li>
          de Bello F., Šmilauer P., Diniz-Filho J.A.F., Carmona C.P., <b>Lososová Z.</b>, Herben T. &
          Götzenberger L. (2017): Decoupling phylogenetic and functional diversity to reveal hidden
          signals in community assembly. <i>Methods in Ecology and Evolution</i> 8: 1200–1211.
        </li>

   <li>
          <b>Lososová Z.</b>, <b>Čeplová N.</b>, <b>Chytrý M.</b>, <b>Tichý L.</b>, <b>Danihelka J.</b>, Fajmon K., <b>Láníková D.</b>,
          <b> Preislerová Z.</b> & <b>Řehořek V.</b> (2016): Is phylogenetic diversity a good proxy for functional
          diversity of plant communities? A case study from urban habitats. <i>Journal of Vegetation
          Science</i> 27: 1036–1046. –{" "}
          <a href="http://onlinelibrary.wiley.com/doi/10.1111/jvs.12414/epdf">
            fulltext in Wiley Online Library
          </a>
        </li>

<li>
          <b>Čeplová N.</b>, <b>Lososová Z.</b>, <b>Zelený D.</b>, <b>Chytrý M.</b>, <b>Danihelka J.</b>, Fajmon K., <b> Láníková D.</b>, <b>Preislerová Z.</b>, <b>Řehořek V.</b> &amp; <b>Tichý L.</b> (2015): Phylogenetic diversity of central-
          European urban plant communities: effects of alien species and habitat types. <i>Preslia</i> 87:
          1–16. –{" "}
          <a href="http://www.sci.muni.cz/botany/chytry/Ceplova_etal2015_Preslia.pdf">
            fulltext in PDF
          </a>
        </li>
        
        
     
        <li>
          <b>Lososová Z.</b>, <b>Šmarda P.</b>, <b>Chytrý M.</b>, Purschke O., Pyšek P., Sádlo J., <b>Tichý L.</b> & Winter M. 
          (2015): Phylogenetic structure of plant species pools reflects habitat age on the
          geological time scale. <i>Journal of Vegetation Science</i> 26: 1080–1089. –{" "}
          <a href="http://onlinelibrary.wiley.com/doi/10.1111/jvs.12308/epdf">
            fulltext in Wiley Online Library
          </a>
        </li>
        <h4>Popularizační články</h4>
        <li>
          <b>Lososová Z.</b>, <b>Chytrý M.</b> & Pyšek P. (2018): Známe odpověď na Darwinovu naturalizační
          hádanku? <i>Živa</i> 5: 229–230. –{" "}
          <a href="http://www.ziva.avcr.cz/files/ziva/pdf/zname-odpoved-na-darwinovu-naturalizacni-hadanku.pdf">
            fulltext in pdf
          </a>
        </li>
      </div>
    </div>
  )
};
